import { AxiosResponse } from "axios";
import { apisiseci } from "./api";
import { AttendanceLocalUser } from "../@types/attendance-local-user";
import { CreateAttendanceUsersParams } from "./api-tansquery/attendance-local/user/create";

type UserCreatePayload = CreateAttendanceUsersParams;

export const userCreate = (
    params: UserCreatePayload
): Promise<AxiosResponse<AttendanceLocalUser>> => {
    const token = localStorage.getItem("gov_access_token_sso");
    const bodyRequest = params;
    return apisiseci.post("/cms/u_usuarios/", bodyRequest, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
